import React from 'react';
import {Input, message, Modal, Typography} from 'antd';
import {projectsApi} from '@/api/projects';
import type {ProjectRequest, ProjectResponse} from '@/types';

const {Text} = Typography;

interface IEditProjectModalProps {
	project: ProjectResponse | null;
	setProject: (project: ProjectResponse) => void;
	open: boolean;
	onClose: () => void;
}

const EditProject: React.FC<IEditProjectModalProps> = ({open, project, setProject, onClose}) => {
	const [editName, setEditName] = React.useState('');
	const [editDescription, setEditDescription] = React.useState('');
	const [editLoading, setEditLoading] = React.useState(false);

	async function handleEditProject() {
		if (!project?.id || !editName.trim()) {
			message.warning('Введите название проекта');
			return;
		}

		const payload: ProjectRequest = {
			name: editName.trim(),
			description: editDescription.trim() || undefined,
		};

		setEditLoading(true);
		const {data, error} = await projectsApi.update(project.id, payload);
		setEditLoading(false);

		if (error) {
			message.error(error.message || 'Не удалось сохранить проект');
		} else if (data) {
			setProject(data);
			message.success('Проект обновлён');
			onClose();
		}
	}

	React.useEffect(() => {
		if (open && project) {
			setEditName(project.name);
			setEditDescription(project.description ?? '');
		} else {
			setEditName('');
			setEditDescription('');
		}
	}, [open, !!project]);

	return (
		<Modal
			title="Редактирование проекта"
			open={open}
			onOk={handleEditProject}
			onCancel={onClose}
			confirmLoading={editLoading}
			okText="Сохранить"
			cancelText="Отмена"
		>
			<div style={{display: 'flex', flexDirection: 'column', gap: 16, padding: '16px 0'}}>
				<div>
					<Text strong>Название</Text>
					<br />
					<Input
						value={editName}
						onChange={e => setEditName(e.target.value)}
						placeholder="Название проекта"
						style={{width: '100%', marginTop: 4}}
					/>
				</div>
				<div>
					<Text strong>Описание</Text>
					<br />
					<Input.TextArea
						value={editDescription}
						onChange={e => setEditDescription(e.target.value)}
						placeholder="Описание (необязательно)"
						rows={3}
						maxLength={2000}
						showCount
						style={{width: '100%', marginTop: 4, resize: 'vertical'}}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default EditProject;
